<template>
  <div class="container">
    <h4>{{ i18nJS.activity.activityOrders }}</h4>
    <div class="insert">
      <div class="margin-right-10">
        <div>{{ i18nJS.activity.item }}</div>
        <v-select2 @input="selectItem($event)" :selectConfig="getConfig" :withCredentials="true"></v-select2>
      </div>
      <div class="margin-right-10">
        <div>Qta</div>
        <input type="number" class="input-micro" placeholder="Qta" style="margin: 0" v-model="itemQta" />
      </div>
      <div v-if="itemSelected && itemSelected.items_convs && itemSelected.items_convs.length > 0" class="margin-right-10">
        <div>{{ i18nJS.activity.udm }}</div>
        <select v-model="udmSelected" class="select2" style="margin: 0">
          <option :value="null">{{ i18nJS.activity.package }}</option>
          <option :value="conv" v-for="(conv, index) in itemSelected.items_convs" :key="index">{{ conv.format }}</option>
        </select>
      </div>
      <button
        type="button"
        class="btn btn-link no_border"
        :disabled="(!itemSelected && !itemQta) || (itemQta && itemQta <= 0)"
        @click="addItem()"
      >
        <i class="fa-light fa-plus pulsante_comando"></i>
      </button>
    </div>
    <div>
      <generic-table
        :headerLabels="headerLabels"
        :elements="getTableElements"
        :options="options"
        @removeElementEvent="removeItem"
      ></generic-table>
      <!-- campi hidden per inserire l'oggetto come nested attributes -->
      <div v-for="item in tableElements" :key="item.id">
        <input
          v-for="key in activitiesBriefcaseKeys"
          :key="key"
          type="hidden"
          :name="`activities_config[activities_briefcases_attributes][][${key}]`"
          :value="item[key]"
        />
      </div>
      <!-- devo aggiungere _destroy perchè rails lo elimini -->
      <div v-for="(item, index) in removedElements" :key="index">
        <input type="hidden" :name="'activities_config[activities_briefcases_attributes][][id]'" :value="item.id" />
        <input type="hidden" :name="'activities_config[activities_briefcases_attributes][][_destroy]'" :value="1" />
      </div>
    </div>
  </div>
</template>
<script>
import vSelect2 from '../vSelect2';
import genericTable from '../genericTable/genericTable';
import { warehouseApiConnector } from '../../starApiConnector';
import { getCookie } from '../../plugins/userUtils';
import { Route } from '../../route';

export default {
  name: 'activities-briefcase',
  components: {
    vSelect2,
    genericTable,
  },
  data() {
    return {
      itemSelected: null,
      itemQta: 0,
      udmSelected: null,
      headerLabels: [i18nJS.activity.item, 'qta', i18nJS.activity.udm],
      activitiesBriefcaseKeys: ['w_item_id', 'w_conv_id', 'qta', 'activities_config_id', 'id'],
      tableElements: [],
      removedElements: [],
      options: { actionColumnEnabled: true, canDeleteRow: true },
      activitiesConfigId: null,
      wUrl: `${warehouseApiConnector().defaults.baseURL}/items`,
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
    getConfig() {
      return {
        placeholder: `${window.i18nJS.activity.selectEl}`,
        url: this.wUrl,
        headers: {
          'HTTP-X-EPERSONAM-BU-ID': window.config.business_unit.id,
        },
        processResults: this.processResults,
      };
    },
    getTableElements() {
      return this.tableElements.map(
        // [{name, qta, umd, ....}] -> [{name, qta, umd}]
        ({ name, qta, item_udm }) => ({ name, qta, item_udm }),
      );
    },
  },
  mounted() {
    this.activitiesConfigId = $('#activities-briefcase').data('activity-config-id');
    const data = $('#activities-briefcase').data('activitiesBriefcases');
    if (data) {
      data.forEach((element) => {
        warehouseApiConnector()
          .get(`items/${element.w_item_id}`)
          .then((response) => {
            const udm = response.data.items_convs.find((conv) => conv.id === element.w_conv_id);
            // If request is good...
            element.name = response.data.name;
            element.item_udm = udm ? udm.format : i18nJS.activity.package;
            element.activities_config_id = this.activitiesConfigId;
            this.tableElements.push(element);
          })
          .catch((error) => {
            console.log('error ' + error);
          });
      });
    }
  },
  methods: {
    selectItem(item) {
      this.udmSelected = null;
      this.itemSelected = JSON.parse(item);
    },
    removeItem(item, index) {
      // mi serve rimuoverlo solo se è presente l'id
      if (this.tableElements[index].id) {
        this.removedElements.push(this.tableElements[index]);
      }
      this.tableElements.splice(index, 1);
    },
    addItem() {
      // se l'elemento non è presente lo aggiungo
      if (
        !this.tableElements.find(
          (el) =>
            el.name === this.itemSelected.name &&
            el.item_udm === ((this.udmSelected && this.udmSelected.format) || i18nJS.activity.package),
        )
      ) {
        this.tableElements.push({
          name: this.itemSelected.name,
          qta: this.itemQta,
          item_udm: this.udmSelected ? this.udmSelected.format : i18nJS.activity.package,
          w_item_id: this.itemSelected.id,
          w_conv_id: this.udmSelected ? this.udmSelected.id : null,
          activities_config_id: this.activitiesConfigId,
        });
        this.$emit('changedItemsEvent', this.tableElements);
      }
    },
    processResults(data) {
      if (data) {
        return {
          results: data.map((res) => {
            return { text: res.name, id: JSON.stringify(res) };
          }),
          pagination: {
            more: data.length === 30,
          },
        };
      } else {
        return {};
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 10px 30px 30px 30px;
  width: 91%;
}
.insert {
  display: flex;
  margin-top: 20px;
  width: 100%;
  align-items: flex-end;
}
.pulsante_comando {
  font-size: 15px;
  margin: 0px 3px;
  vertical-align: middle;
  border: solid 1px;
  border-radius: 100%;
  padding: 11px;
}
.pulsante_comando.fa-plus {
  padding: 6px 8px;
}
.no_border {
  border: none;
  outline: none;
  padding: 5px;
}
select {
  height: 34px;
}
.margin-right-10 {
  margin-right: 10px;
}
</style>
